import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Enable credentials for httpOnly cookie auth (same-origin fallback)
axios.defaults.withCredentials = true;

// Auto-attach Bearer token for cross-origin auth
let interceptorRegistered = false;
if (!interceptorRegistered) {
  axios.interceptors.request.use(config => {
    const token = sessionStorage.getItem('adminToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });
  interceptorRegistered = true;
}

export { API };
export default axios;
